import React from 'react';
import { Drawer } from '@datanomik/commons-ui';
import type { DrawerProps, IconButtonProps } from '@mui/material';
import { IconButton } from '@mui/material';
import { CloseLine } from '@datanomik/commons-ui/icons';

export type ClosableDrawerProps = DrawerProps & {
  hideCloseButton?: boolean;
  closeButtonProps?: Omit<IconButtonProps, 'onClick' | 'aria-label'>;
};

export const ClosableDrawer: React.FC<ClosableDrawerProps> = ({
  children,
  hideCloseButton = false,
  closeButtonProps,
  ...props
}) => {
  const handleCloseClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Support both MUI's onClose signature and plain () => void used across the app
    if (typeof props.onClose === 'function') {
      try {
        (props.onClose as any)(event, 'closeButtonClick');
      } catch {
        try {
          (props.onClose as unknown as () => void)();
        } catch {
          // no-op
        }
      }
    }
  };

  return (
    <Drawer {...(props as any)}>
      <div style={{ position: 'relative', height: '100%' }}>
        {!hideCloseButton && (
          <IconButton
            aria-label="close"
            onClick={handleCloseClick}
            sx={{
              position: 'absolute', top: 10, right: 8, zIndex: 1,
            }}
            {...closeButtonProps}
          >
            <CloseLine />
          </IconButton>
        )}
        {children}
      </div>
    </Drawer>
  );
};

export default ClosableDrawer;
